import SectionLabel from "@/components/base/SectionLabel";
import { aiOfficeData } from "@/mocks/aiOfficeData";

export default function ExamplesSection() {
  return (
    <section id="examples" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-14 reveal">
          <SectionLabel label={aiOfficeData.examples.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {aiOfficeData.examples.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {aiOfficeData.examples.categories.map((cat, catIdx) => (
            <div
              key={cat.name}
              className="reveal rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-7"
              style={{ transitionDelay: `${catIdx * 100}ms` }}
            >
              <div className="flex items-center gap-3 mb-5 pb-4 border-b border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500 text-lg`} />
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading">
                  {cat.name}
                </h3>
              </div>
              <ul className="space-y-3">
                {cat.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-foreground-700">
                    <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10 reveal">
          <p className="text-xs text-foreground-500">
            これ以外の業務についてもお気軽にご相談ください
          </p>
        </div>
      </div>
    </section>
  );
}